import { useMemo, useState } from 'react';

import { CreateToastOptions, ToastList, ToastOptions } from './Toast.types';

let counter = 0;

export function useToastList(defaultOptions: CreateToastOptions) {
  const [toastList, setToastList] = useState<ToastList>([]);

  const toastConfig = useMemo(() => {
    const createToast: (options: CreateToastOptions) => ToastOptions = (options) => {
      counter += 1;
      const id = options.id ?? counter;

      return {
        id,
        ...options,
        open: true
      };
    };

    const addToast: (options?: CreateToastOptions) => number = (options) => {
      const toast = createToast({ ...defaultOptions, ...options } as CreateToastOptions);

      setToastList((prevToasts) => {
        return [...prevToasts, toast];
      });

      return toast.id;
    };

    const close = (id: number) => {
      setToastList((prevState) => {
        return prevState.filter((toast) => toast.id !== id);
      });
    };

    return { close, addToast };
  }, [defaultOptions]);

  return { toastConfig, toastList };
}
